import React, { useState, useEffect } from 'react';
import { ButtonGroup, Button, Tabs, Tab } from '@mui/material';
import TimesheetsReport from '../../../components/Reports_V2/TimesheetsReport';
import WorkflowFormDialog from 'src/components/forms/WorkflowForm/WorkflowFormDialog';
import GridLayoutComponent from 'src/components/GridLayoutComponent/GridLayoutComponent';
import './DayCareEmployeeHome.css'
import moment from 'moment';
import axios from 'axios'
import { APIURL } from '../../../config'

const DayCareEmployeeHome = (props) => {
    const [value, setValue] = useState('1');
    const [presentCustomers, setPresentCustomers] = useState([]);
    const [showWorkflow, setShowWorkflow] = useState(false);

    useEffect(() => {
        getActiveSessions();
    }, [])

    useEffect(() => {
        const checkTokenExpiry = () => {
            props.checkTokenExpiry();
        };
        checkTokenExpiry();
    }, [props])

    const getActiveSessions = async () => {
        const today = moment().format('YYYY-MM-DD');
        let companySessionsResponse = await axios.get(APIURL + `/sessions/company/${props.user.comp_id}`, {
            params: { startDate: today, endDate: today }
        });

        console.log(companySessionsResponse);
        
        const currentTime = moment.utc();

        const activeSessions = companySessionsResponse.data.filter(session => {
            const checkInTime = session.check_in_time ? moment.utc(session.check_in_time) : null;
            const checkOutTime = session.check_out_time ? moment.utc(session.check_out_time) : null;
            
            // Active if checked in and either not checked out yet, or current time is between check-in and check-out
            if (checkInTime && checkInTime.isSameOrBefore(currentTime)) {
                // If no check-out time, session is still active
                if (!checkOutTime) {
                    return true;
                }
                console.log(checkInTime.isSameOrBefore(currentTime), checkOutTime.isSameOrAfter(currentTime), currentTime.format('YYYY-MM-DD HH:mm:ss'), checkInTime.format('YYYY-MM-DD HH:mm:ss'), checkOutTime.format('YYYY-MM-DD HH:mm:ss'));
                // If check-out time exists, check if current time is before check-out
                return checkOutTime.isSameOrAfter(currentTime);
            }
            return false;
        });

        console.log(activeSessions);
        
        setPresentCustomers(activeSessions);
    }

    return (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Tabs
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    value={value}
                >
                    <Tab onClick={() => setValue('1')} label="Home" value="1" />
                    <Tab onClick={() => setValue('2')} label="Timesheet Reports" value="2" />
                </Tabs>
                <ButtonGroup size="small" sx={{ height: "40px", whiteSpace: "nowrap" }}>
                    {props.user.permissions.CreateNewWorkflow && <Button size="small" variant="contained" onClick={() => setShowWorkflow(true)}>NEW WORKFLOW</Button>}
                </ButtonGroup>
            </div>
            {value === '1' &&
                <GridLayoutComponent
                    {...props}
                    checkTokenExpiry={props.checkTokenExpiry}
                    user={props.user}
                    comp_id={props.comp_id}
                    presentCustomers={presentCustomers}
                    getActiveSessions={getActiveSessions}
                />
            }
            {value === '2' &&
                <div style={{ width: '98%' }}>
                    <TimesheetsReport user={props.user} pagesize={20} comp_id={props.comp_id} />
                </div>
            }
            <div>
                <WorkflowFormDialog {...props} open={showWorkflow} handleClose={() => setShowWorkflow(false)} />
            </div>
        </div>
    )
}

export default DayCareEmployeeHome;